import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme) => ({
  appBar: {
    padding: 0,
    borderBottom: `0.2px solid ${theme.palette.secondary.tint15}`,
    backgroundColor: "inherit",
    "& .MuiTab-wrapper": {
      fontSize: "60%",
      fontWeight: "bold",
        color: theme.palette.secondary.main,
    },
    "& button": {
      minWidth: [theme.spacing(50), "!important"],
    },
  },
  extraTextContainer: {
    display: "flex",
    height: "70%",
    alignItems: "center",
    width: "100%",
    justifyContent: "space-around",
    marginLeft: -theme.spacing(5),
  },
  popOver: {
    minHeight: theme.spacing(48),
    minWidth: theme.spacing(144),
    backgroundColor: theme.palette.secondary.tint90,
    border: `1px solid ${theme.palette.secondary.tint60}`,
    borderRadius: theme.spacing(4),
    boxShadow:
      "0 20px 30px 0 rgba(0, 0, 0, 0.1), 0 30px 30px 0 rgba(0, 0, 0, 0.1)",
    color: theme.palette.secondary.tint15,
    direction: "ltr",
    overflow: "hidden",
    padding: theme.spacing(6),
  },
  popOverContainer: {
    marginTop: -theme.spacing(10),
    marginRight: -theme.spacing(5),
  },
  icon: {
    cursor: "pointer",
  },
}));
